import { SettingsBackupRestore } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MuiUtil from '@/util/MuiUtil';

class IconeVotoRevogado extends Component {
    static titlePadrao = 'Voto Revogado';
    static corPadrao = 'darkorange';
    static opacidadePadrao = '0.7';
    removerTooltip = false;
    removerEstiloPadrao = false;

    static get sxPadrao() {
        return {
            color: IconeVotoRevogado.corPadrao,
            fill: IconeVotoRevogado.corPadrao,
            fillOpacity: IconeVotoRevogado.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        let { removerEstiloPadrao, removerTooltip, title, ...propsIcone } = this.props;

        // Carrega as propriedades do tooltip
        this.removerTooltip = removerTooltip !== undefined ? removerTooltip : this.removerTooltip;
        this.title = title !== undefined ? title : IconeVotoRevogado.titlePadrao;

        // Carrega as propriedades do ícone
        this.removerEstiloPadrao = removerEstiloPadrao !== undefined ? removerEstiloPadrao : this.removerEstiloPadrao;

        if (this.removerEstiloPadrao) {
            this.propsIcone = propsIcone;
        } else {
            this.propsIcone = MuiUtil.mesclarSxStyle(propsIcone);
            this.adicionarSxPadrao();
        }
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            this.propsIcone.sx = IconeVotoRevogado.sxPadrao;
        } else {
            this.propsIcone.sx = { ...IconeVotoRevogado.sxPadrao, ...this.propsIcone.sx };
        }
    }

    render() {
        if (this.removerTooltip) {
            return <SettingsBackupRestore {...this.propsIcone} />;
        } else {
            return (
                <Tooltip title={this.title}>
                    <SettingsBackupRestore {...this.propsIcone} />
                </Tooltip>
            );
        }
    }
}

IconeVotoRevogado.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node
};

export default IconeVotoRevogado;
